import { Component, inject, OnDestroy } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { HistorySheetComponent } from './history-sheet.component';
import { HistorySheetService } from './history-sheet.service';

/**
 * The drawer the History sheet slides out of, wrapped around the app's content.
 *
 * `MatSidenav` gives us the backdrop, the Escape handler, the focus trap and the focus restore that
 * the CDK overlay this replaced had to wire up by hand — but a drawer only exists inside a
 * `mat-sidenav-container`, and that container has to be an ancestor of the page. Hence the
 * `ng-content`: the layout wraps its content in this, and the trigger down in the header opens the
 * sheet through `HistorySheetService` rather than by reaching for a component instance.
 *
 * The sheet itself is mounted only while it is on screen, because one mounting is one run as far as
 * its telemetry is concerned.
 */
@Component({
  templateUrl: './history-sheet-container.component.html',
  standalone: true,
  selector: 'app-history-sheet-container',
  imports: [MatSidenavModule, HistorySheetComponent],
})
export class HistorySheetContainerComponent implements OnDestroy {
  protected readonly sheet = inject(HistorySheetService);

  /** Escape and backdrop clicks close the drawer itself; the service has to hear about both. */
  onOpenedChange(opened: boolean): void {
    if (!opened) this.sheet.close();
  }

  ngOnDestroy(): void {
    // The layout is rebuilt on every navigation, and a sheet that survived the move would come back
    // already open on a page the merchant never opened it from.
    this.sheet.close();
    this.sheet.markClosed();
  }
}
